import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'dmv-pub-page-service-unavailable',
    templateUrl: './page-service-unavailable.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageServiceUnavailableComponent {
}
